export const CategoryGame = [
    {
        key: "all",
        title: "ทั้งหมด",
        image: "icons/3d/all.svg",
    },
    {
        key: "slot",
        title: "สล็อต",
        image: "icons/3d/slot.svg",
    },
    {
        key: "casino",
        title: "คาสิโน",
        image: "icons/3d/casino.svg",
    },
    {
        key: "poker",
        title: "เกมไพ่",
        image: "icons/3d/poker.svg",
    },
    {
        key: "sport",
        title: "กีฬา",
        image: "icons/3d/sport.svg",
    },
    {
        key: "lotto",
        title: "หวย",
        image: "icons/3d/lotto.svg",
    },
]

export const CategoryGameAMBKing = [
    {
        key: "all",
        title: "ทั้งหมด",
        image: "icons/3d/all.svg",
    },
    {
        key: "slot",
        title: "สล็อต",
        image: "icons/3d/slot.svg",
    },
    {
        key: "casino",
        title: "คาสิโน",
        image: "icons/3d/casino.svg",
    },
    {
        key: "fish",
        title: "ปลา",
        image: "icons/3d/fish.svg",
    },
    {
        key: "sport",
        title: "กีฬา",
        image: "icons/3d/sport.svg",
    },
    {
        key: "lotto",
        title: "หวย",
        image: "icons/3d/lotto.svg",
    },
    {
        key: "card",
        title: "การ์ด",
        image: "icons/3d/card.svg",
    },
    {
        key: "keno",
        title: "คีโน่",
        image: "icons/3d/keno.png",
    },
    {
        key: "poker",
        title: "เกมไพ่",
        image: "icons/3d/poker.svg",
    },
    {
        key: "trade",
        title: "เทรด",
        image: "icons/3d/trade.svg",
    },
    {
        key: "esport",
        title: "อีสปอร์ต",
        image: "icons/3d/esport.svg",
    },
]

export const CategoryGameAMBKing1 = [
    {
        key: "slot",
        title: "สล็อต",
        image: "icons/3d/slot.svg",
    },
    {
        key: "casino",
        title: "คาสิโน",
        image: "icons/3d/casino.svg",
    },
    {
        key: "fish",
        title: "ปลา",
        image: "icons/3d/fish.svg",
    },
    {
        key: "sport",
        title: "กีฬา",
        image: "icons/3d/sport.svg",
    },
    {
        key: "lotto",
        title: "หวย",
        image: "icons/3d/lotto.svg",
    },
    {
        key: "card",
        title: "การ์ด",
        image: "icons/3d/card.svg",
    },
    {
        key: "keno",
        title: "คีโน่",
        image: "icons/3d/keno.png",
    },
    {
        key: "poker",
        title: "เกมไพ่",
        image: "icons/3d/poker.svg",
    },
    {
        key: "trade",
        title: "เทรด",
        image: "icons/3d/trade.svg",
    },
    {
        key: "esport",
        title: "อีสปอร์ต",
        image: "icons/3d/esport.svg",
    },
]

export const CategoryGamePJJAZZ = [
    {
        key: "pgsoft",
        title: "PG Soft",
        image: "/logo-pg.png",
    },
    {
        key: "pragmatic",
        title: "pragmatic",
        image: "/logo-pragmatic.png",
    },
]